<template>
<article class="comment" :id="'comment' + comment.uuid" :class="{ active: comment.commentView.submitCommentFlag, 'old-comment': comment.member_id === 'MT' }">
  <header class="comment__header">
    <user-info :userData="comment.author" :timeStamp="comment.created_at"></user-info>
    <comment-option :userData="comment.author" :uuid="comment.uuid" :replyKey="comment.reply_key" v-if="comment.commentView.optionBtnFlag"></comment-option>
  </header>
<!-- uuid: <b>{{comment.uuid}}</b><br> -->
<!-- comment.state: {{comment.status}} -->
  <p class="comment__body" :class="getCommentBodyClass" v-text="comment.body" v-if="comment.status === 0 || jFlag === 1"></p>

  <p class="comment__body comment__body--delete" v-if="!(comment.status === 0)"><!-- デフォルト -->
    <span v-if="comment.status === 1">このコメントはユーザーが削除しました。</span>
    <span v-if="comment.status === 2">このコメントはガイドラインに違反したため削除されました。<br><a href="https://www.j-cast.com/etc/comment_guide.html" class="text-link" target="_blank">コメントガイドライン</a></span>
    <span v-if="comment.status === 3 && jFlag !== 1">複数のユーザーの指摘により、コメントを非公開にしています。<br><a href="#">コメントのガイドライン</a></span>
  </p>

  <footer class="comment__footer">
    <comment-reply :i="i" :comment="comment" :replyCount="comment.replyCount" v-if="comment.commentView.replyBtnFlag"></comment-reply>
    <comment-vote :good="comment.good" :bad="comment.bad" :uuid="comment.uuid" :replyKey="comment.reply_key" v-if="comment.commentView.voteBtnFlag"></comment-vote>
  </footer>
</article>
</template>

<script>
import userInfo from '../../molecules/userInfo/userInfo'
import commentOption from '../../molecules/commentOption/commentOption'
import commentVote from '../../molecules/commentVote/commentVote'
import commentReply from '../../molecules/commentReply/commentReply'

export default {
  name: 'comment',
  props: {
    comment: Object,
    i: Number
  },
  components: {
    'user-info': userInfo,
    'comment-option': commentOption,
    'comment-reply': commentReply,
    'comment-vote': commentVote
  },
  computed: {
    getCommentBodyClass: function () {
      const diffNum = this.comment.good - this.comment.bad
      if (this.$pageType !== 'comment') {
        return 'comment-eval0'
      } else {
        // 10以上
        if (diffNum >= 10) {
          return 'comment-eval3'
        }

        // 3以上
        if (diffNum >= 3) {
          return 'comment-eval2'
        }

        // 1以上
        if (diffNum >= 1) {
          return 'comment-eval1'
        }

        // 0
        if (diffNum === 0) {
          return 'comment-eval0'
        }

        // -10以下
        if (diffNum <= -10) {
          return 'comment-eval-3'
        }

        // -3以下
        if (diffNum <= -3) {
          return 'comment-eval-2'
        }

        // -1以下
        if (diffNum <= -1) {
          return 'comment-eval-1'
        }
        return 'comment-eval0'
      }
    }
  },
  mounted: function () {
    // 追加要素のアニメーション リスナー
    // 複数ある場合、最初の要素のみ activeを付け直す、か。
    this.$nextTick(function () {
      const activeElm = document.querySelector('#comment' + this.comment.uuid)
      activeElm.addEventListener('animationend', function () {
        // コメント連投時 1つ前のコメントの要素を継承してしまうので goodBadがdisabled trueをfalseにして機能はするように
        const activeVoteBtnElm = document.querySelectorAll('#comment' + this.comment.uuid + ' .comment__footer .comment-vote .btn')
        activeVoteBtnElm.forEach(function (btnItem) {
          btnItem.disabled = false
        })
        // console.log(activeElm, 'アニメーション終了')

        activeElm.classList.remove('active')
        this.comment.commentView.submitCommentFlag = false
      }.bind(this))

      // ie11用 foreach classListが動作しなかった edgeもMSAnimationEnd拾ってる気が、、、
      activeElm.addEventListener('MSAnimationEnd', function () {
        const activeGoodBtnElm = document.querySelectorAll('#comment' + this.comment.uuid + ' .comment__footer .comment-vote .btn-good')
        const activeBadBtnElm = document.querySelectorAll('#comment' + this.comment.uuid + ' .comment__footer .comment-vote .btn-bad')
        for (let i = 0; i < activeGoodBtnElm.length; i++) {
          activeGoodBtnElm[i].disabled = false
        }
        for (let j = 0; j < activeBadBtnElm.length; j++) {
          activeBadBtnElm[j].disabled = false
        }

        activeElm.setAttribute('class', 'comment') // remove('active')
        this.comment.commentView.submitCommentFlag = false
      }.bind(this))
    })
  },
  methods: {
  }
}
</script>

<style lang="scss" src="./comment.scss"></style>



// WEBPACK FOOTER //
// src/components/organisms/comment/comment.vue